import { DictionaryMessage } from "../../../../../../bayadic-shared-models/classes/message/DictionaryMessage";
import { AbstractChatMessage } from "../../../../../../bayadic-shared-models/classes/message/abstract-chat-message";
import { ChatMessage } from "../../../../../../bayadic-shared-models/classes/message/chat-message";
import { LeitnerMessage } from "../../../../../../bayadic-shared-models/classes/message/LeitnerMessage";
import { InteractiveChatJourneyMessage } from "../../../../../../bayadic-shared-models/classes/message/InteractiveJourneyChatMessage";
import { MESSAGE_TYPES } from "../../../../../../bayadic-shared-models/item/message-types";
import { LessonMessage } from "../../../../../../bayadic-shared-models/classes/message/LessonMessage";
import { QuizMessage } from "../../../../../../bayadic-shared-models/classes/quiz/quiz-message";
export class MessageFactory {
    getMessage(messageType: MESSAGE_TYPES): AbstractChatMessage {
        switch(messageType) {
            case MESSAGE_TYPES.Dictionary:
                return new DictionaryMessage()
            case MESSAGE_TYPES.Leitner:
                return new LeitnerMessage()
            case MESSAGE_TYPES.Chat:
                return new ChatMessage()
            case MESSAGE_TYPES.InteractiveChatJourney:
                return new InteractiveChatJourneyMessage()            
            case MESSAGE_TYPES.Lesson:
                return new LessonMessage()
            case MESSAGE_TYPES.Quiz:
                return new QuizMessage()
            
        }
    }
}